import React from 'react';
import {
    Button,
    Composite,
    Heading,
    Icon,
    Level,
    Text,
    Variant,
    Size,
    useTheme,
    Group,
    AlertTriangleIcon,
    RefreshIcon,
} from '@defa/defa-component-library';
import { Root } from './error.styles';
import i18n from '@i18n';

type Props = {
    title?: string;
    description?: string;
    onRetry?: () => void;
    onSecondary?: () => void;
    secondaryText?: string;
};

export const ErrorPage: React.FC<Props> = (props) => {
    const { title, description, onRetry, onSecondary, secondaryText } = props;

    const theme = useTheme();

    const resolvedTitle =
        title ??
        i18n.t('Errors.SectionHeader', {
            defaultValue: 'We couldn’t load this section',
        });

    const resolvedDescription =
        description ??
        i18n.t('Errors.Generic', {
            defaultValue: 'Something went wrong. Please try again.',
        });

    const resolvedSecondaryText =
        secondaryText ??
        i18n.t('Back', {
            defaultValue: 'Go back',
        });

    return (
        <Root>
            <Group tight>
                <Composite justify="start" gap={20} paddingVertical={theme.spacingRaw(1)}>
                    <Icon icon={AlertTriangleIcon} size={40} color={theme.border.accent} />
                    <Heading level={Level.h3}>{resolvedTitle}</Heading>
                </Composite>

                <Text alignment="center" color={theme.foreground.subtle}>
                    {resolvedDescription}
                </Text>
            </Group>

            <Composite gap={theme.spacingRaw(2)} align="center">
                {onRetry && (
                    <Button
                        name="fullpage-retry"
                        variant={Variant.PRIMARY}
                        size={Size.NORMAL}
                        icon={RefreshIcon}
                        onClick={onRetry}
                        text={i18n.t('Retry')}
                    />
                )}
                {onSecondary && (
                    <Button
                        name="fullpage-secondary"
                        variant={Variant.GRAYSCALE}
                        size={Size.NORMAL}
                        onClick={onSecondary}
                        text={resolvedSecondaryText}
                    />
                )}
            </Composite>
        </Root>
    );
};
